// extracted by mini-css-extract-plugin
export default {"noteRow":"NotesTable__noteRow___NV9Kq","icon":"NotesTable__icon___UQhB1","clearFilter":"NotesTable__clearFilter___JmU4e","headings":"NotesTable__headings___DNGDa"};